"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_tz_1 = require("date-fns-tz");
const locale_1 = require("date-fns/locale");
const dateString = 'eee MMM dd yyyy';
const timeString = `h:mm:ss a`;
const dateTimeString = `${dateString}, ${timeString}`;
const yearMonthDayString = 'yyyy-MM-dd';
const iso8601 = "yyyy-MM-dd'T'HH:mm:ssXXX";
// TODO move this to rafflebox-lib ???
const formatDateTime = (val, options) => {
    if (!val) {
        return '';
    }
    let formatString = '';
    if (options && options.format === 'date') {
        formatString = dateString;
    }
    else if (options && options.format === 'time') {
        formatString = timeString;
    }
    else if (options && options.format === 'dateTime') {
        formatString = dateTimeString;
    }
    else if (options && options.format === 'iso8601') {
        formatString = iso8601;
    }
    else {
        formatString = yearMonthDayString;
    }
    if (options && options.timeZone) {
        const zonedTime = date_fns_tz_1.utcToZonedTime(val, options.timeZone);
        if (options.displayTimeZone) {
            formatString += ' (z)';
        }
        if (options.locale === 'fr') {
            return date_fns_tz_1.format(zonedTime, formatString, { timeZone: options.timeZone, locale: locale_1.frCA });
        }
        return date_fns_tz_1.format(zonedTime, formatString, { timeZone: options.timeZone });
    }
    if (options && options.locale === 'fr') {
        return date_fns_tz_1.format(val, formatString, { locale: locale_1.frCA });
    }
    return date_fns_tz_1.format(val, formatString);
};
exports.formatDateTime = formatDateTime;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS10aW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zvcm1hdHRlcnMvZGF0ZS10aW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkNBQXFEO0FBQ3JELDRDQUF1QztBQUV2QyxNQUFNLFVBQVUsR0FBRyxpQkFBaUIsQ0FBQztBQUNyQyxNQUFNLFVBQVUsR0FBRyxXQUFXLENBQUM7QUFDL0IsTUFBTSxjQUFjLEdBQUcsR0FBRyxVQUFVLEtBQUssVUFBVSxFQUFFLENBQUM7QUFDdEQsTUFBTSxrQkFBa0IsR0FBRyxZQUFZLENBQUM7QUFDeEMsTUFBTSxPQUFPLEdBQUcsMEJBQTBCLENBQUM7QUFTM0Msc0NBQXNDO0FBQ3RDLE1BQU0sY0FBYyxHQUFHLENBQUMsR0FBOEIsRUFBRSxPQUErQixFQUFVLEVBQUU7SUFDakcsSUFBSSxDQUFDLEdBQUcsRUFBRTtRQUNSLE9BQU8sRUFBRSxDQUFDO0tBQ1g7SUFFRCxJQUFJLFlBQVksR0FBRyxFQUFFLENBQUM7SUFFdEIsSUFBSSxPQUFPLElBQUksT0FBTyxDQUFDLE1BQU0sS0FBSyxNQUFNLEVBQUU7UUFDeEMsWUFBWSxHQUFHLFVBQVUsQ0FBQztLQUMzQjtTQUFNLElBQUksT0FBTyxJQUFJLE9BQU8sQ0FBQyxNQUFNLEtBQUssTUFBTSxFQUFFO1FBQy9DLFlBQVksR0FBRyxVQUFVLENBQUM7S0FDM0I7U0FBTSxJQUFJLE9BQU8sSUFBSSxPQUFPLENBQUMsTUFBTSxLQUFLLFVBQVUsRUFBRTtRQUNuRCxZQUFZLEdBQUcsY0FBYyxDQUFDO0tBQy9CO1NBQU0sSUFBSSxPQUFPLElBQUksT0FBTyxDQUFDLE1BQU0sS0FBSyxTQUFTLEVBQUU7UUFDbEQsWUFBWSxHQUFHLE9BQU8sQ0FBQztLQUN4QjtTQUFNO1FBQ0wsWUFBWSxHQUFHLGtCQUFrQixDQUFDO0tBQ25DO0lBRUQsSUFBSSxPQUFPLElBQUksT0FBTyxDQUFDLFFBQVEsRUFBRTtRQUMvQixNQUFNLFNBQVMsR0FBRyw0QkFBYyxDQUFDLEdBQUcsRUFBRSxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUM7UUFFeEQsSUFBSSxPQUFPLENBQUMsZUFBZSxFQUFFO1lBQzNCLFlBQVksSUFBSSxNQUFNLENBQUM7U0FDeEI7UUFFRCxJQUFJLE9BQU8sQ0FBQyxNQUFNLEtBQUssSUFBSSxFQUFFO1lBQzNCLE9BQU8sb0JBQU0sQ0FBQyxTQUFTLEVBQUUsWUFBWSxFQUFFLEVBQUUsUUFBUSxFQUFFLE9BQU8sQ0FBQyxRQUFRLEVBQUUsTUFBTSxFQUFFLGFBQUksRUFBRSxDQUFDLENBQUM7U0FDdEY7UUFFRCxPQUFPLG9CQUFNLENBQUMsU0FBUyxFQUFFLFlBQVksRUFBRSxFQUFFLFFBQVEsRUFBRSxPQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQztLQUN4RTtJQUVELElBQUksT0FBTyxJQUFJLE9BQU8sQ0FBQyxNQUFNLEtBQUssSUFBSSxFQUFFO1FBQ3RDLE9BQU8sb0JBQU0sQ0FBQyxHQUFHLEVBQUUsWUFBWSxFQUFFLEVBQUUsTUFBTSxFQUFFLGFBQUksRUFBRSxDQUFDLENBQUM7S0FDcEQ7SUFFRCxPQUFPLG9CQUFNLENBQUMsR0FBRyxFQUFFLFlBQVksQ0FBQyxDQUFDO0FBQ25DLENBQUMsQ0FBQztBQUVPLHdDQUFjIn0=